var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLamp1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 247,
    viewBox: "0 0 82 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4639_123189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8895 219.98C17.7095 219.98 17.5495 219.85 17.5195 219.66C17.5095 219.59 16.3195 212.21 16.0395 206.47C16.0295 206.26 16.1895 206.09 16.3995 206.08C16.5995 206.08 16.7795 206.23 16.7895 206.44C17.0695 212.14 18.2495 219.48 18.2595 219.55C18.2895 219.75 18.1495 219.95 17.9495 219.98C17.9295 219.98 17.9095 219.98 17.8895 219.98Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6094 185.33C22.9094 178.64 36.2094 177.85 40.3494 179.34C40.3494 179.34 37.5094 174.58 40.0294 172.76C42.9194 170.67 48.0494 173.88 49.1194 179.05C49.1194 179.05 51.8994 173.19 56.0194 173.89C60.1394 174.59 55.3194 185.34 55.3194 185.34H20.6094V185.33Z",
    fill: "#8EBF8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7394 178.11C32.7394 178.34 33.5194 184.38 27.6894 187.86C21.8594 191.34 20.6094 187.86 20.6094 187.86L25.1794 182.93L32.7394 178.11Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3106 181.09C52.0906 179.09 45.9706 182.62 45.1406 189.44L51.7206 190.28L57.3106 181.09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4991 184.39H8.78906C15.2591 208.34 36.5391 208.27 44.4891 208.27C52.4391 208.27 73.7191 208.34 80.1891 184.39H44.4991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7901 234.56C72.6201 234.56 72.4601 234.44 72.4201 234.26C72.0301 232.39 71.9201 227.14 71.7801 221.06C71.6301 214.11 71.4601 206.23 70.8501 200.7C69.6401 189.75 66.6601 184.39 64.5301 181.3C64.4101 181.13 64.4501 180.9 64.6201 180.78C64.7901 180.66 65.0201 180.71 65.1401 180.87C67.3201 184.02 70.3601 189.5 71.5901 200.61C72.2001 206.17 72.3801 214.07 72.5301 221.03C72.6601 227.07 72.7701 232.29 73.1501 234.1C73.1901 234.3 73.0601 234.5 72.8601 234.54C72.8301 234.54 72.8101 234.54 72.7801 234.54L72.7901 234.56Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3763 187.4C15.2363 183.39 3.56633 176.84 0.636325 182.13C-3.19367 189.04 11.4363 191.6 13.3763 187.4Z",
    fill: "#4B764A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7092 173.94C73.6492 176.18 71.7692 179.25 69.5792 181.16C67.4492 183.02 65.0292 183.79 63.7292 181.61C60.6392 176.41 69.9492 168.83 73.0392 171.98C73.5292 172.48 73.7292 173.16 73.7092 173.94Z",
    fill: "#8EBF8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1961 202.48C79.0361 203.57 77.0662 203.18 75.1362 202.09C71.9462 200.28 68.8562 196.56 69.7162 194.45C69.8462 194.13 70.0662 193.84 70.3962 193.61C75.3062 190.07 83.4161 199.45 80.1961 202.48Z",
    fill: "#4B764A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0777 222.17C68.6677 225.75 77.4177 216.35 73.5877 211.67C69.9177 207.17 63.8577 219.1 66.0777 222.17Z",
    fill: "#8EBF8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.026 231.61C70.016 234.51 65.196 236.13 64.266 233.6C63.446 231.38 67.066 226.58 70.436 224.68C71.106 224.29 71.766 224.03 72.376 223.92C73.186 223.77 73.906 223.89 74.466 224.4C74.736 224.63 74.966 224.95 75.146 225.36C76.086 227.47 74.906 229.79 73.026 231.61Z",
    fill: "#8EBF8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7261 212.08C19.9361 212.82 17.6361 210.96 16.0061 208.47C13.7461 205.04 12.7761 200.41 16.2461 199.86C17.6461 199.64 18.9261 200.1 19.9961 200.96C23.4861 203.76 24.8461 210.78 21.7261 212.08Z",
    fill: "#8EBF8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25856 218.3C7.30856 220.26 15.4786 216.01 11.7286 211.27C9.11856 207.97 2.59856 215.76 5.25856 218.3Z",
    fill: "#8EBF8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9961 200.96C19.2661 204.76 17.2261 207.26 16.0061 208.47C13.7461 205.04 12.7761 200.41 16.2461 199.86C17.6461 199.64 18.9261 200.1 19.9961 200.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7094 173.94C73.6494 176.18 71.7694 179.25 69.5794 181.16C68.9994 181.33 68.6194 181.44 68.6194 181.44C68.4294 181.43 67.2494 176.33 73.7094 173.94Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1519 225.36C74.9719 224.95 74.7419 224.63 74.4719 224.4L72.3819 223.92C71.7719 224.03 71.1119 224.29 70.4419 224.68C70.1719 226.99 70.7919 229.87 73.0319 231.61C74.9119 229.79 76.0919 227.47 75.1519 225.36Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1362 202.09C71.9462 200.28 68.8562 196.56 69.7162 194.45C71.5062 195.05 75.0562 196.9 75.1362 202.09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4894 206.29C13.9094 209.08 22.3294 200.52 18.6694 195.69C15.0194 190.87 6.89937 203.36 10.4894 206.29Z",
    fill: "#4B764A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8292 179.18C81.2291 174.8 69.0192 175.4 68.4092 181.42C67.7992 187.44 82.4592 183.76 81.8292 179.18Z",
    fill: "#4B764A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3959 199.2C61.7959 202.91 71.7759 194.78 68.6959 189.57C65.7359 184.57 56.8859 195.32 59.3959 199.2Z",
    fill: "#8EBF8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7519 246.33C76.5419 248.43 79.4319 233.3 73.2919 232.62C68.8219 232.12 67.1919 245.04 70.7519 246.33Z",
    fill: "#4B764A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2231 209.58C78.6431 209.54 75.4731 196.32 68.8131 197.56C63.1031 198.62 68.0631 209.63 74.2231 209.58Z",
    fill: "#4B764A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3899 231.59C83.5899 231.1 78.5599 218.19 72.4199 220.11C67.1499 221.75 73.5499 232.27 79.3899 231.59Z",
    fill: "#4B764A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8284 187.67C53.6584 191.06 63.1284 185.87 59.9884 180.7C57.0884 175.93 47.8684 184.12 50.8284 187.67Z",
    fill: "#4B764A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8011 175.86C35.0611 171.5 18.7211 176.07 19.5711 183.19C20.5111 191.04 36.5811 180.42 35.8011 175.86Z",
    fill: "#4B764A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9629 225.16C22.3829 225.01 22.7429 213.14 16.6929 213.05C12.4829 212.99 13.3429 225.32 17.9629 225.16Z",
    fill: "#4B764A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5028 208.64C44.2928 208.64 44.1328 208.47 44.1328 208.26V0.38C44.1328 0.17 44.3028 0 44.5028 0C44.7028 0 44.8728 0.17 44.8728 0.38V208.26C44.8728 208.47 44.7028 208.64 44.5028 208.64Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29362 187.89C9.20362 187.89 9.12362 187.86 9.04362 187.8C8.88362 187.66 8.87362 187.43 9.00362 187.27L44.2036 146.64C44.2736 146.56 44.3736 146.51 44.4836 146.51C44.5936 146.51 44.6936 146.56 44.7636 146.64L79.7536 187.06C79.8936 187.22 79.8736 187.45 79.7136 187.59C79.5536 187.73 79.3236 187.71 79.1836 187.55L44.4736 147.46L9.58362 187.76C9.51362 187.85 9.40362 187.89 9.30362 187.89H9.29362Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4639_123189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81.85,
    height: 246.53,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp1);
export default __webpack_public_path__ + "static/media/lamp-1.a7b9b1c2954562bb1a67faa8e6137b40.svg";
export { ForwardRef as ReactComponent };